import logo from './logo.svg';
import React, { useEffect } from 'react';

import './App.css';
import Header from './Components/Header';
import Body from './Components/Body';
import Landingpage from './Landingpage';
import { Route, Routes } from 'react-router-dom';
import CheckInpage from './Components/CheckInpage';
import Navbar from './Components/Navbar/Navbar';
import AppRoutes from './Components/AppRoutes';
import SurveyPage from './Components/Survey/SurveyPage';

function App() {

  // console.log('window',window.scrollY);
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollHeight = window.scrollY;
  //     console.log('Scroll Height:', scrollHeight,window);
  //     // You can use the scrollHeight as needed
  //   };
  //   console.log('Attaching scroll event listener');

  //   // Attach the event listener when the component mounts
  //   document.addEventListener('scroll', handleScroll);

  //   // Detach the event listener when the component unmounts
  //   return () => {
  //     document.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);
  return (
  <div className="w-screen h-screen  overflow-auto scroll-smooth ">
        {/* <div className="flex  w-full items-center justify-between px-4 pl-[26px] sm:px-[60px]  py-[12px] tracking-wide h-[4.44rem] text-[#9EA9B8] "> */}
        <Navbar />
        {/* </div> */}
        <div className="w-full h-[calc(100vh-71px)]">
          <AppRoutes />
        </div>
    
    
    {/* <Routes>
    <Route path="/" element={<Landingpage />} />
    <Route path="/waitlist" element={<CheckInpage />} />

   </Routes> */}
    {/* <Route path="/survey" element={<SurveyPage />} /> */}
  </div>
  );
}

export default App;
